import React from 'react';

import { AuthContext, AuthContextType, AuthContextUser } from 'contexts';

type AuthContextProviderProps = {
  auth: AuthContextUser;
};

const AuthContextProvider: React.FC<AuthContextProviderProps> = ({
  auth,
  children,
}) => (
    <AuthContext.Provider
      value={
        {
          auth,
        } as AuthContextType
      }
    >
      {children}
    </AuthContext.Provider>
  );

export default AuthContextProvider;
